"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["color", "size", "className", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RouteToIcon = function RouteToIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.517 8.809l2.81 2.809-.708.707L9 10.705V15H8v-4.26l-1.585 1.585-.707-.707zM8.5 8A1.5 1.5 0 1 1 10 6.5 1.5 1.5 0 0 1 8.5 8zm0-1a.5.5 0 1 0-.5-.5.5.5 0 0 0 .5.5zm0-6a5.491 5.491 0 0 0-4.011 9.25l.702-.725a4.5 4.5 0 1 1 6.618 0l.702.726A5.491 5.491 0 0 0 8.5 1z"
    }));
  }

  if (size <= 24) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M12.5 12.793l2.847 2.847-.707.707-1.64-1.64V22h-1v-7.293l-1.64 1.64-.707-.707zm0-1.793A1.5 1.5 0 1 1 14 9.5a1.5 1.5 0 0 1-1.5 1.5zm0-1a.5.5 0 1 0-.5-.5.5.5 0 0 0 .5.5zm0-7.8a7.289 7.289 0 0 0-5.302 12.302l.707-.706a6.3 6.3 0 1 1 9.273-.092l.707.707A7.287 7.287 0 0 0 12.5 2.201z"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 12.5a1.5 1.5 0 1 0-1.5 1.5 1.5 1.5 0 0 0 1.5-1.5zm-2 0a.5.5 0 1 1 .5.5.5.5 0 0 1-.5-.5zm.5 4.293l3.854 3.854-.707.707L17 18.707V29h-1V18.707l-2.646 2.646-.707-.707zm9.3-4.293a9.254 9.254 0 0 1-2.472 6.293l-.707-.707a8.3 8.3 0 1 0-12.242 0l-.707.707A9.294 9.294 0 1 1 25.8 12.5z"
  }));
};

var _default = RouteToIcon;
exports["default"] = _default;